import { ResourceCard } from "@organisms/ResourceCard";
import { QuoteMarkers } from "@/components/atoms/QuoteMarkers";
import { quotesPosition } from "@/shared/quotesMarkers";
import { allResources } from "./variables";

export const Resources = () => {
  const ResourceElement = document.createElement("div");
  ResourceElement.className =
    "app-container grid md:grid-cols-2 border border-gray-100 divide-x divide-y divide-gray-100 lg:grid-cols-3 relative";

  quotesPosition.forEach((position) => {
    ResourceElement.appendChild(QuoteMarkers(position));
  });

  allResources.forEach((resource) => {
    ResourceElement.appendChild(ResourceCard(resource));
  });

  return ResourceElement;
};
